<script setup lang="ts">
import { computed } from 'vue';
import FilterFieldLayout from './FilterFieldLayout.vue';
import { SearchFilter, FilterOption, MultipleFilterOptions } from '../../../search-panel-types';
import FilterSwitch from './FilterSwitch.vue';

type Props = {
  filters: MultipleFilterOptions[];
  label: string;
  selected: { value: SearchFilter };
};

const props = defineProps<Props>();
const filtersToShow = computed(() => props.filters.filter((item) => item.options.length > 0));
const hideFilter = computed(
  () =>
    !filtersToShow.value.some((filter) =>
      filter.options.some((option: FilterOption) => option.count !== 0 && Number(option.label) !== 0),
    ),
);
</script>

<template>
  <FilterFieldLayout v-if="!hideFilter" v-show="filtersToShow.length > 0" :label="props.label ?? ''" class="mb-2">
    <template #content>
      <FilterSwitch
        v-for="filter in filtersToShow"
        :key="filter.field.aggregationKey"
        :filter-key="filter.field.aggregationKey"
        :items="filter.options"
        :selected="selected"
        :label="filter.field.label"
        @filters-updated="(params) => $emit('filters-updated', params)"
      />
    </template>
  </FilterFieldLayout>
</template>

<style scoped lang="scss"></style>
